import { jsx as _jsx } from "react/jsx-runtime";
import legalDocuments from '@phishtool/legal-documents';
import Legal from '~components/legal';
const PrivacyPolicy = () => _jsx(Legal, { heading: "Privacy Policy", content: legalDocuments.privacyPolicy });
export default PrivacyPolicy;
